<template>
  <!-- 我想被補導 -->
  <f7-page class="counseling-search-page">
    <f7-navbar title="申請輔導" back-link="Back">
      <f7-nav-right>
        <f7-link icon="icon-bars" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <header class="wave-header sticky-top">
      <!-- Searchbar with auto init -->
      <form class="searchbar">
        <div class="searchbar-inner">
          <div class="searchbar-input-wrap">
            <input type="search" placeholder="搜尋科目" v-model="searchSubject"/>
            <i class="searchbar-icon"></i>
            <span class="input-clear-button"></span>
          </div>
        </div>
      </form>
    </header>

    <!-- 搜尋結果 -->
    <f7-list media-list v-if="!searchflag">
      
        <template v-for="(item,index) in searchResult" >
          <f7-list-item 
            :title="item.chineseName"
            :text="item.introduce"
            @click="transferToApply(item.studentNo,item.introduce)"
          >
            <img slot="media" src="../../../images/icon/profile-account.png" />
          </f7-list-item>
        </template>
      <!--
      <f7-list-item
        link="/apply"
        title="黃子瑜"
        text="阿拉伯語學系年級：一年級主修：英語教學副修：語言與文學第二外語：日文、法文專長：語言教學、英語教學興趣：學習外語、旅行"
      >
        <img slot="media" src="https://randomuser.me/api/portraits/women/60.jpg" />
      </f7-list-item>
      <f7-list-item
        link="/"
        title="董佳佳"
        text="英語學系年級：三年級主修：英語教學副修：語言與文學第二外語：日文、法文專長：語言教學、英語教學興趣：學習外語、旅行"
      >
        <img slot="media" src="https://randomuser.me/api/portraits/women/90.jpg" />
      </f7-list-item>
      <f7-list-item
        link="/"
        title="賈比爾"
        text="日文學系年級：四年級主修：英語教學副修：語言與文學第二外語：日文、法文專長：語言教學、英語教學興趣：學習外語、旅行"
      >
        <img slot="media" src="https://randomuser.me/api/portraits/men/92.jpg" />
      </f7-list-item>
    -->
    </f7-list>
  </f7-page>
</template>

<script>
import PopModalTest from "./PopModalTest";
import axios from '../../../js/axiosModule';
import { bus } from '../../../js/bus';

var moment = require('moment');
export default {
  components: {},
  data() {
    return {
      title: "pop page",
      searchSubject:'',
      finalSearchKey:'',
      searchflag:false,
      searchResult:[],
      checked: true
    };
  },
  created: function() {},
  mounted() {},
  methods: {
    openPrompt: function() {
      this.$dialog.modal({
        component: PopModalTest,
        title: "確認申請",
        showCloseBtn: this.checked,
        params: { firstInput: "" },

        callback: p => {
          this.$dialog.alert("已送出", { type: "success", showIcon: false });
        }
      });
    },
    checkHref: function(linkText) {
      this.$f7router.navigate("/" + linkText);
    },
    getNowTime : function() {
      var today = new Date();
      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      
      var dateTime = moment(date+' '+time, "YYYY-MM-DD HH:mm:ss")._d;
      return dateTime;
    },
    transferToApply:function(studentNo,chineseName,introduce){
      let self = this;
      return new Promise((resolve,reject) => {
        this.$f7router.navigate("/apply");
        setTimeout(
          function() {
            bus.$emit('applyBus',{"introduce":introduce,"chineseName":chineseName,"applyStudentNo":studentNo,"searchTerm":self.finalSearchKey});
          }
        ,100);
      });
      
      
    }
  },
  watch: {
    searchSubject :function(value) {
      let self = this;
      if (value.length >= 2 ) {
        var params={};
        self.searchflag = true;
        params.queryString=value;
        params.coachType=10;
        params.activeTime=self.getNowTime();
        params.cansearch=true;
        self.finalSearchKey = value;
        axios.axiosTokenPost(self.$app.axiosUrl+"/api/Coach/GetCoachTutorByKeyword",params).then((response)=> {
          self.searchResult = response.data.data;
          self.searchflag = false;
        }).catch(err=>function() {
          if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
            self.$f7router.navigate("/login");
          } 
        });
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/counseling-apply/counseling-search.vue